export default "__VITE_ASSET__BxOMqFYA__"